import { queryOrThrow } from "@rootreeweb/js-lib";

const contentSelector = ".rt-not-translated";

/**
 * Returns the English copy.
 *
 * @param url The URL to link to.
 * @returns The English copy.
 */
function getENCopy(url: string) {
	return `We’re working on it, but in the meantime, you can <a href="${url}">enjoy it in its original language</a>.`;
}

/**
 * Returns the French copy.
 *
 * @param url The URL to link to.
 * @returns The French copy.
 */
function getFRCopy(url: string) {
	return `Nous y travaillons, mais en attendant, vous pouvez en <a href="${url}">profiter dans sa langue d’origine</a>.`;
}

/**
 * Returns the previous page from the query string.
 *
 * @returns The previous page.
 */
function getEncodedURL() {
	const url = new URL(window.location.toString());
	const urlMatch = url.search.match(/previous_page=(.+)$/i);
	return urlMatch?.[1];
}

/**
 * Returns the HTML content for the page.
 *
 * @param cleanedURL The cleaned URL to link to.
 * @returns The HTML content for the page
 */
function getHTML(cleanedURL: string) {
	return `<div>${getFRCopy(cleanedURL)}<br>${getENCopy(cleanedURL)}</div>`;
}

/**
 * Initializes the page not translated page. This page is shown when a page is
 * only available in one language. The page will show a message in both English
 * and French with a link to the original page.
 *
 * @throws Error If the previous page is not provided in the query string.
 */
export function pageNotTranslated(): void {
	const contentElement = queryOrThrow(contentSelector);
	const encodedURL = getEncodedURL();
	if (!encodedURL) {
		throw new Error("Previous page not provided in query string");
	}

	const cleanedURL = decodeURIComponent(encodedURL);

	contentElement.innerHTML = getHTML(cleanedURL);
}
